<template>
  <section :id="data.id" class="bg-gray-lighten3 py-10 xl:py-14">
    <div class="container">
      <div class="bg-white py-10 xl:rounded-lg xl:px-12 xl:py-14">
        <UiSectionTitle
          class="title mb-6 pl-6 text-[24px] uppercase leading-none text-slate xl:mb-8 xl:text-center xl:text-[32px]"
          :title="data.title"
        />
        <ul class="flex xl:flex-wrap xl:justify-center">
          <li
            v-for="(partner, i) in data.partners"
            :key="i"
            class="xl:basis-[calc(100%/5-16px)]"
          >
            <UiLink
              v-if="partner.link"
              :to="partner.link"
              class="flex h-[52px] w-[120px] items-center justify-center rounded border border-solid border-gray-lighten1 hover:border-slate xl:h-[104px] xl:w-auto"
            >
              <CdnImg
                :src="partner.image.src"
                :alt="partner.image.alt"
                class="block max-h-[21px] w-auto max-w-full xl:max-h-[41px]"
              />
            </UiLink>
            <div
              v-else
              class="flex h-[52px] w-[120px] items-center justify-center rounded border border-solid border-gray-lighten1 hover:border-slate xl:h-[104px] xl:w-auto"
            >
              <CdnImg
                :src="partner.image.src"
                :alt="partner.image.alt"
                class="block max-h-[21px] w-auto max-w-full xl:max-h-[41px]"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import UiLink from '~/components/ui/UiLink.vue';
import UiSectionTitle from '~/components/ui/UiSectionTitle.vue';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});
</script>

<style lang="scss" scoped>
.container {
  @media screen and (max-width: 1439px) {
    padding: 0;
  }
}
ul {
  @media screen and (max-width: 1439px) {
    overflow: auto visible;
  }
  @media screen and (min-width: 1440px) {
    margin-top: -16px;
  }
  &::-webkit-scrollbar {
    @media screen and (max-width: 1439px) {
      width: 0;
      height: 0;
    }
  }
  li {
    flex-shrink: 0;
    @media screen and (min-width: 1440px) {
      margin-top: 16px;
    }
    &:not(:last-child) {
      margin-right: 16px;
    }
    &:first-child {
      @media screen and (max-width: 1439px) {
        margin-left: 24px;
      }
    }
    &:last-child {
      @media screen and (max-width: 1439px) {
        margin-right: 24px;
      }
    }
  }
}
</style>
